import React, { useState } from "react";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { WvcLogo } from '@/integrations/wordpress/WvcLogo';
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList, navigationMenuTriggerStyle } from "@/components/ui/navigation-menu";
import { Sheet, SheetContent, SheetTrigger, SheetHeader, SheetTitle } from "@/components/ui/sheet";
import { Menu, X } from "lucide-react";
import { cn } from "@/lib/utils";
function HeaderMenuConsumer({
  onItemClick
}: {
  onItemClick?: () => void;
}) {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex flex-col gap-4 md:flex-row">
        {[1, 2, 3].map(i => <div key={i} data-index={i} className="h-4 w-20 animate-pulse rounded-md bg-muted" />)}
      </div>;
  }
  return <NavigationMenu viewport={false} className="max-w-full">
      <NavigationMenuList className="flex-col items-start gap-4 md:flex-row md:items-center md:gap-6">
        {menuItems.map((item, i) => <NavigationMenuItem key={item.id} data-index={i}>
            <NavigationMenuLink asChild className={cn(navigationMenuTriggerStyle(), "bg-transparent hover:bg-transparent hover:text-primary px-0 text-sm font-medium uppercase tracking-widest")}>
              <Link to={item.href || "#"} onClick={onItemClick}>
                {item.label}
              </Link>
            </NavigationMenuLink>
          </NavigationMenuItem>)}
      </NavigationMenuList>
    </NavigationMenu>;
}
export default function Header() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  return <MenuProvider menu_id="16" className="fixed top-0 left-0 z-50 w-full border-b border-border/40 bg-background/80 backdrop-blur-md">
      <section data-section-id="264125" id="header" className="w-full">
        <div className="container mx-auto px-4">
          <div className="flex h-20 items-center justify-between">
            {}
            <div className="flex items-center">
              <Link to="/">
                <WvcLogo className="h-7 w-auto" />
              </Link>
            </div>

            {}
            <div className="hidden md:block">
              <HeaderMenuConsumer />
            </div>

            {}
            <div className="flex items-center gap-4">
              <Button variant="outline" size="sm" className="hidden rounded-md border-primary/20 text-[10px] font-bold uppercase tracking-widest sm:inline-flex" asChild>
                <Link to="/RSVPPage">
                  RSVP
                </Link>
              </Button>

              {}
              <Sheet open={mobileMenuOpen} onOpenChange={setMobileMenuOpen}>
                <SheetTrigger asChild>
                  <Button variant="ghost" size="icon" className="md:hidden" aria-label="Toggle Menu">
                    <Menu className="size-6" />
                  </Button>
                </SheetTrigger>
                <SheetContent side="right" className="w-[300px] bg-background p-6">
                  <SheetHeader className="mb-8 text-left">
                    <SheetTitle className="text-sm font-medium uppercase tracking-widest">Menu</SheetTitle>
                  </SheetHeader>
                  <div className="flex flex-col gap-8">
                    <MenuProvider menu_id="16">
                      <HeaderMenuConsumer onItemClick={() => setMobileMenuOpen(false)} />
                    </MenuProvider>
                    <Button variant="outline" size="sm" className="w-full rounded-md border-primary/20 text-[10px] font-bold uppercase tracking-widest" asChild>
                      <Link to="/RSVPPage" onClick={() => setMobileMenuOpen(false)}>
                        RSVP
                      </Link>
                    </Button>
                  </div>
                </SheetContent>
              </Sheet>
            </div>
          </div>
        </div>
      </section>
    </MenuProvider>;
}